import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text, Hint } from 'components/common/Elements/Elements';

import classes from './TextWidget2.module.scss';

const TextWidget2 = ({
  data: { title, value, only90 },
  className,
  tooltip
}) => {
  return (
    <div className={cn(classes.box, className ? className : classes.box_size)}>
      <div className={classes.titleWrap}>
        <Text size={6}>{title}</Text>
        {tooltip && (
          <Hint className={classes.hint} text={tooltip} position="top" />
        )}
      </div>
      <Text weight="b" className={classes.value}>
        {value}
      </Text>
      {only90 && (
        <Text size={2} className={classes.only90}>
          *value for last 90 days
        </Text>
      )}
    </div>
  );
};

TextWidget2.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    only90: PropTypes.bool
  }).isRequired,
  className: PropTypes.string,
  tooltip: PropTypes.string
};

export default TextWidget2;
